<template>
  <CommonLayout header="DeliveryEvaluationHeader" footer="DeliveryEvaluationFooter">
    <b-overlay :show="overlayShow" rounded="sm">
      <div class="container" style="max-width: 3420px;">
        <div class="evalution-main-color text-light row mt-3">
          <div class="col p-2">
            納品報告画像評価
          </div>
        </div>

        <div id="search-box" class="row mt-3 base-color" style="margin-right: 20%;">
          <div class="accordion col p-0" role="tablist">
            <b-card no-body style="overflow: visible !important;">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-1 id='search-bar' class="light-green text-left" @click="changeIcon()"><b-icon id="icon-up" icon="chevron-up"></b-icon><b-icon id="icon-down" class="hide" icon="chevron-down"></b-icon>&nbsp;検索条件</b-button>
              </b-card-header>
              <!-- 制作案件一覧検索BOX -->
              <b-collapse visible id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <form method="post" action="#" class="form-horizontal">

                    <div class="form-group row">
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <label for="area-date" class="control-label col-sm-12">エリア</label>
                          <div class="col-sm-12 pr-0">
                            <v-select id="area-date" v-model="searchAreaName" label="label" :options="areaData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="areaData.length <= 0" :disabled="fixedProductionBaseCode != ''"></v-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <label for="unit-date" class="control-label col-sm-12">ユニット</label>
                          <div class="col-sm-12 pr-0">
                            <v-select id="unit-date" v-model="searchUnitName" label="label" :options="unitData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="unitData.length <= 0" :disabled="fixedProductionBaseCode != ''"></v-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <label for="facility-date" class="control-label col-sm-12">施設</label>
                          <div class="col-sm-12 pr-0">
                            <v-select id="facility-date" v-model="searchFacilityName" label="label" :options="facilityData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="facilityData.length <= 0"></v-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <label for="productionBase-date" class="control-label col-sm-12">制作拠点</label>
                          <div class="col-sm-12 pr-0">
                            <v-select id="productionBase-date" v-model="searchProductionBaseCode" label="label" :options="productionBaseData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="productionBaseData.length <= 0" :disabled="fixedProductionBaseCode != ''"></v-select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <b-form-group label="施行日From" label-for="wedding-date-from" class="form-group-date">
                            <b-form-datepicker
                              id="wedding-date-from"
                              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                              locale="jp"
                              v-model="searchDateFrom"
                              class="datepicker">
                            </b-form-datepicker>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <b-form-group label="施行日To" label-for="wedding-date-to" class="form-group-date">
                            <b-form-datepicker
                              id="wedding-date-to"
                              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                              locale="jp"
                              v-model="searchDateTo"
                              class="datepicker">
                            </b-form-datepicker>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <label for="detailType-date" class="control-label col-sm-12">明細種別</label>
                          <div class="col-sm-12 pr-0">
                            <v-select id="detailType-date" v-model="searchDetailTypeName" label="label" :options="getDetailType()" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple></v-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <div class="col-sm-12 px-0">
                          <label for="evaluation-date" class="control-label col-sm-12">総合評価</label>
                          <div class="col-sm-12 pr-0">
                            <v-select id="evaluation-date" v-model="searchEvaluation" label="label" :options="getEvaluation()" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple></v-select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-sm-5 row">
                        <div class="row col-sm-12">
                          <label class="control-label col-sm-12">評価</label>
                          <div class="col-sm-3 custom-control align-items-center" >
                            <input name="evaluationSet" type="radio" id="inlineRadio1" value="1" v-model="searchEvaluationSet" key="input-radio1">
                            <label class="ml-1" for="inlineRadio1">済</label>
                          </div>
                          <div class="col-sm-3 custom-control align-items-center" >
                            <input name="evaluationSet" type="radio" id="inlineRadio2" value="0" v-model="searchEvaluationSet" key="input-radio2" checked="checked">
                            <label class="ml-1" for="inlineRadio2">未</label>
                          </div>
                          <div class="col-sm-3 custom-control align-items-center" >
                            <input name="evaluationSet" type="radio" id="inlineRadio3" value="" v-model="searchEvaluationSet" key="input-radio3">
                            <label class="ml-1" for="inlineRadio3">全て</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="text-center mt-4">
                      <b-button variant="outline-secondary" type="reset" class="w-25 white-btn" @click="clearConditions()">リセット</b-button>
                      <b-button class="evalution-main-color text-light w-25 ml-3" @click="evaluationSearch()">検索</b-button>
                    </div>
                  </form>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>

        <!-- 案件制作一覧リスト -->
        <div id="search-list" class="row base-color mt-3">
          <div class="col-sm-12 mt-3">
            <b-table-simple bordered class="small">
              <thead role="rowgroup" class="table-bordered">
                <tr role="row" class="align-middle">
                  <th colspan="21" class="align-middle text-center" style="position: sticky; background-color: white !important; color: black !important;">
                    <div class="col-sm-12 row pt-3 pr-0">
                      <div class="col-sm-6 text-left">
                        検索結果<span class="h3 ml-1">{{viewLength}}</span><span class="ml-1 mr-2">件</span>{{viewLength > 0 ? pageStart + 1 : 0}} - {{pageEnd}}件を表示
                      </div>
                      <div class="col-sm-6 text-right pr-0">
                        <b-button variant="primary" @click="evaluationRegist()" :disabled="(viewLength === 0)">保存</b-button>
                        <b-button variant="outline-secondary" @click="caseIntroductionJudge()" disabled>事例紹介判定</b-button>
                      </div>
                    </div>
                  </th>
                </tr>
                <tr role="row" class="align-middle">
                  <th rowspan="2" class="align-middle text-center" style="width: 4%;" @click="sortBy('No')">{{strSortDirection('No')}}</th>
                  <th rowspan="1" class="align-middle text-center" style="width: 8%;" @click="sortBy('案件番号')">案件番号{{strSortDirection('案件番号')}}</th>
                  <th rowspan="1" class="align-middle text-center" style="width: 10%;" @click="sortBy('施設名')">施設{{strSortDirection('施設名')}}</th>
                  <th rowspan="1" class="align-middle text-center" style="width: 8%;" @click="sortBy('スタイル')">スタイル{{strSortDirection('スタイル')}}</th>
                  <th rowspan="2" class="align-middle text-center" style="width: 6%;">大区分</th>
                  <th rowspan="2" class="align-middle text-center" style="width: 10%;">画像</th>
                  <th rowspan="2" class="align-middle text-center" style="width: 16%;">金額</th>
                  <th rowspan="2" class="align-middle text-center" style="width: 6%;">評価項目</th>
                  <th rowspan="2" class="align-middle text-center" style="width: 8%;">評価</th>
                  <th rowspan="2" class="align-middle text-center" style="width: 12%;">コメント</th>
                  <th rowspan="2" class="align-middle text-center" style="width: 8%;" @click="sortBy('総合評価')">総合評価{{strSortDirection('総合評価')}}</th>
                  <th rowspan="2" class="align-middle text-center" style="width: 4%;" @click="sortBy('事例紹介')">事例紹介{{strSortDirection('事例紹介')}}</th>
                </tr>
                <tr>
                  <th class="align-middle text-center" @click="sortBy('施工日')">施行日{{strSortDirection('施工日')}}</th>
                  <th class="align-middle text-center" @click="sortBy('ご両家名')">ご両家名{{strSortDirection('ご両家名')}}</th>
                  <th class="align-middle text-center" @click="sortBy('打合せ種別')">明細種別{{strSortDirection('打合せ種別')}}</th>
                </tr>
              </thead>
              <template v-for="(project, index) in activeViewList">
                <b-tbody :key="index + 'tbody'" :class="index % 2 === 1 ? 'gray-line' : 'white-line'">
                  <b-tr :key="index + 'activeProject' + 0">
                    <b-td :rowspan="project['表示行数'] * evaluationItems.length" class="align-middle">{{project['No']['value']}}</b-td>
                    <b-td :rowspan="project['表示行数'] * evaluationItems.length" class="align-middle">
                      <a :href="project['案件番号リンク']['value']" target="_blank">{{project['案件番号']['value']}}</a>
                      <br><br>
                      {{formatDate(project['施工日']['value'])}}
                    </b-td>
                    <b-td :rowspan="project['表示行数'] * evaluationItems.length" class="align-middle">
                      {{project['施設名']['value']}}
                      <br><br>
                      <a class="move_link" @click="moveDeliveredImage(project['打合せ参加ID']['value'])">{{project['ご両家名']['value']}}</a>
                    </b-td>
                    <b-td :rowspan="project['表示行数'] * evaluationItems.length" class="align-middle">
                      {{project['スタイル']['value']}}
                      <br><br>
                      {{project['打合せ種別']['value']}}
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行0_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行0_大区分']}}<br>
                      <input class="" type="checkbox" name="evaluationCheckBox" value="1" v-model="project['表示行0_総合評価対象']" @change="viewComprehensiveEvaluation(index)" :disabled="(project['評価商品テーブル']['value'].length <= 0 || !userEvaluationAuthority)">
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行0_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">
                      <b-button class="image-box" @click="handleOpenDialog(project['表示行0_画像'])">
                        <img :src="project['表示行0_画像']" class="mw-100 tile-image-height" v-if="project['表示行0_画像'] !== ''">
                      </b-button>
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行0_総合評価対象'] ? 'align-middle text-pre-wrap nonEvaluation' : 'align-middle text-pre-wrap'">{{project['表示行0_金額']}}</b-td>
                    <b-td rowspan="1" :class="!project['表示行0_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行0_評価項目名'][0]}}</b-td>
                    <b-td rowspan="1" :class="!project['表示行0_総合評価対象'] ? 'align-middle no-pointer-events nonEvaluation' : ((project['評価商品テーブル']['value'].length <= 0 || !userEvaluationAuthority) ? 'align-middle no-pointer-events' : 'align-middle')">
                      <div class="stars">
                        <span>
                          <input :id="'star1_' + index + '_0_0'" type="radio" :name="'star' + index + '_0_0'" v-model="project['表示行0_評価'][0]" value="5" @change="viewComprehensiveEvaluationSub(index, 0)"><label :for="'star1_' + index + '_0_0'">★</label>
                          <input :id="'star2_' + index + '_0_0'" type="radio" :name="'star' + index + '_0_0'" v-model="project['表示行0_評価'][0]" value="4" @change="viewComprehensiveEvaluationSub(index, 0)"><label :for="'star2_' + index + '_0_0'">★</label>
                          <input :id="'star3_' + index + '_0_0'" type="radio" :name="'star' + index + '_0_0'" v-model="project['表示行0_評価'][0]" value="3" @change="viewComprehensiveEvaluationSub(index, 0)"><label :for="'star3_' + index + '_0_0'">★</label>
                          <input :id="'star4_' + index + '_0_0'" type="radio" :name="'star' + index + '_0_0'" v-model="project['表示行0_評価'][0]" value="2" @change="viewComprehensiveEvaluationSub(index, 0)"><label :for="'star4_' + index + '_0_0'">★</label>
                          <input :id="'star5_' + index + '_0_0'" type="radio" :name="'star' + index + '_0_0'" v-model="project['表示行0_評価'][0]" value="1" @click="viewEvaluationReset(index, 0, 0)" @change="viewComprehensiveEvaluationSub(index, 0)"><label :for="'star5_' + index + '_0_0'">★</label>
                        </span>
                      </div>
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行0_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">
                      <b-form-textarea class="w-100 item-note" name="note" rows="8" max-rows="8" no-resize maxlength="300" :style="!project['表示行0_総合評価対象'] ? 'background-color: #e9ecef; padding:0.2rem;' : 'padding:0.2rem;'" v-model="project['表示行0_コメント']" @change="setRowEdit(index)" :disabled="(project['評価商品テーブル']['value'].length <= 0 || !userEvaluationAuthority || !project['表示行0_総合評価対象'])"></b-form-textarea>
                    </b-td>
                    <b-td :rowspan="project['表示行数'] * evaluationItems.length" class="align-middle">
                      <div class="evaluationStars">
                        <span>
                          <label :class="project['総合評価']['value'] >= 5 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars1">★</label>
                          <label :class="project['総合評価']['value'] >= 4 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars2">★</label>
                          <label :class="project['総合評価']['value'] >= 3 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars3">★</label>
                          <label :class="project['総合評価']['value'] >= 2 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars4">★</label>
                          <label :class="project['総合評価']['value'] >= 1 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars5">★</label>
                        </span>
                      </div>
                      <label class="so-big-font ">{{project['総合評価']['value']}}</label>
                    </b-td>
                    <b-td :rowspan="project['表示行数'] * evaluationItems.length" class="align-middle">
                      <div class="custom-control custom-switch text-center ml-2">
                        <input type="checkbox" class="custom-control-input" :id="'toggle-display' + index" :checked="(project['事例紹介']['value'].length != 0)" @change="changeToggle(index)">
                        <label class="custom-control-label" :for="'toggle-display' + index"></label>
                        <input name="projectNumber" :id="'project-number' + index" type="hidden" :value="project['打合せ参加ID']['value']">
                      </div>
                    </b-td>
                  </b-tr>
                  <template v-for="(evaluationItem, index2) in evaluationItems">
                    <b-tr :key="index2 + 'evaluationItem' + 0" v-if="index2 != 0">
                      <b-td rowspan="1" :class="!project['表示行0_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行0_評価項目名'][index2]}}</b-td>
                      <b-td rowspan="1" :class="!project['表示行0_総合評価対象'] ? 'align-middle no-pointer-events nonEvaluation' : ((project['評価商品テーブル']['value'].length <= 0 || !userEvaluationAuthority) ? 'align-middle no-pointer-events' : 'align-middle')">
                        <div class="stars" v-if="project['表示行0_評価項目名'][index2] != '総合評価'">
                          <span>
                            <input :id="'star1_' + index + '_0_' + index2" type="radio" :name="'star' + index + '_0_' + index2" v-model="project['表示行0_評価'][index2]" value="5" @change="viewComprehensiveEvaluationSub(index, 0)"><label :for="'star1_' + index + '_0_' + index2">★</label>
                            <input :id="'star2_' + index + '_0_' + index2" type="radio" :name="'star' + index + '_0_' + index2" v-model="project['表示行0_評価'][index2]" value="4" @change="viewComprehensiveEvaluationSub(index, 0)"><label :for="'star2_' + index + '_0_' + index2">★</label>
                            <input :id="'star3_' + index + '_0_' + index2" type="radio" :name="'star' + index + '_0_' + index2" v-model="project['表示行0_評価'][index2]" value="3" @change="viewComprehensiveEvaluationSub(index, 0)"><label :for="'star3_' + index + '_0_' + index2">★</label>
                            <input :id="'star4_' + index + '_0_' + index2" type="radio" :name="'star' + index + '_0_' + index2" v-model="project['表示行0_評価'][index2]" value="2" @change="viewComprehensiveEvaluationSub(index, 0)"><label :for="'star4_' + index + '_0_' + index2">★</label>
                            <input :id="'star5_' + index + '_0_' + index2" type="radio" :name="'star' + index + '_0_' + index2" v-model="project['表示行0_評価'][index2]" value="1" @click="viewEvaluationReset(index, 0, index2)" @change="viewComprehensiveEvaluationSub(index, 0)"><label :for="'star5_' + index + '_0_' + index2">★</label>
                          </span>
                        </div>
                        <div class="evaluationStars big-font" v-else>
                          {{project['表示行0_評価'][index2]}}
                          <!--
                          <span>
                            <label :class="project['表示行0_評価'][index2] > 4 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars1">★</label>
                            <label :class="project['表示行0_評価'][index2] > 3 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars2">★</label>
                            <label :class="project['表示行0_評価'][index2] > 2 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars3">★</label>
                            <label :class="project['表示行0_評価'][index2] > 1 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars4">★</label>
                            <label :class="project['表示行0_評価'][index2] > 0 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars5">★</label>
                          </span>
                          -->
                        </div>
                      </b-td>
                    </b-tr>
                  </template>
                  <b-tr :key="index + 'activeProject' + 1" v-if="project['表示行数'] > 1">
                    <!--
                    <b-td :rowspan="(project['表示行数'] - 1) * evaluationItems.length" class="align-middle">{{formatDate(project['施工日']['value'])}}</b-td>
                    <b-td :rowspan="(project['表示行数'] - 1) * evaluationItems.length" class="align-middle">
                      <a class="move_link" @click="moveDeliveredImage(project['打合せ参加ID']['value'])">{{project['ご両家名']['value']}}</a>
                    </b-td>
                    <b-td :rowspan="(project['表示行数'] - 1) * evaluationItems.length" class="align-middle">{{project['打合せ種別']['value']}}</b-td>
                    -->
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行1_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行1_大区分']}}<br>
                      <input class="" type="checkbox" name="evaluationCheckBox" value="1" v-model="project['表示行1_総合評価対象']" @change="viewComprehensiveEvaluation(index)" :disabled="(project['評価商品テーブル']['value'].length <= 1 || !userEvaluationAuthority)">
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行1_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">
                      <b-button class="image-box" @click="handleOpenDialog(project['表示行1_画像'])">
                        <img :src="project['表示行1_画像']" class="mw-100 tile-image-height" v-if="project['表示行1_画像'] !== ''">
                      </b-button>
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行1_総合評価対象'] ? 'align-middle text-pre-wrap nonEvaluation' : 'align-middle text-pre-wrap'">{{project['表示行1_金額']}}</b-td>
                    <b-td rowspan="1" :class="!project['表示行1_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行1_評価項目名'][0]}}</b-td>
                    <b-td rowspan="1" :class="!project['表示行1_総合評価対象'] ? 'align-middle no-pointer-events nonEvaluation' : ((project['評価商品テーブル']['value'].length <= 1 || !userEvaluationAuthority) ? 'align-middle no-pointer-events' : 'align-middle')">
                      <div class="stars">
                        <span>
                          <input :id="'star1_' + index + '_1_0'" type="radio" :name="'star' + index + '_1_0'" v-model="project['表示行1_評価'][0]" value="5" @change="viewComprehensiveEvaluationSub(index, 1)"><label :for="'star1_' + index + '_1_0'">★</label>
                          <input :id="'star2_' + index + '_1_0'" type="radio" :name="'star' + index + '_1_0'" v-model="project['表示行1_評価'][0]" value="4" @change="viewComprehensiveEvaluationSub(index, 1)"><label :for="'star2_' + index + '_1_0'">★</label>
                          <input :id="'star3_' + index + '_1_0'" type="radio" :name="'star' + index + '_1_0'" v-model="project['表示行1_評価'][0]" value="3" @change="viewComprehensiveEvaluationSub(index, 1)"><label :for="'star3_' + index + '_1_0'">★</label>
                          <input :id="'star4_' + index + '_1_0'" type="radio" :name="'star' + index + '_1_0'" v-model="project['表示行1_評価'][0]" value="2" @change="viewComprehensiveEvaluationSub(index, 1)"><label :for="'star4_' + index + '_1_0'">★</label>
                          <input :id="'star5_' + index + '_1_0'" type="radio" :name="'star' + index + '_1_0'" v-model="project['表示行1_評価'][0]" value="1" @click="viewEvaluationReset(index, 1, 0)" @change="viewComprehensiveEvaluationSub(index, 1)"><label :for="'star5_' + index + '_1_0'">★</label>
                        </span>
                      </div>
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行1_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">
                      <b-form-textarea class="w-100 item-note" name="note" rows="8" max-rows="8" no-resize maxlength="300" :style="!project['表示行1_総合評価対象'] ? 'background-color: #e9ecef; padding:0.2rem;' : 'padding:0.2rem;'" v-model="project['表示行1_コメント']" @change="setRowEdit(index)" :disabled="(project['評価商品テーブル']['value'].length <= 1 || !userEvaluationAuthority || !project['表示行1_総合評価対象'])"></b-form-textarea>
                    </b-td>
                  </b-tr>
                  <template v-for="(evaluationItem, index2) in evaluationItems" v-if="project['表示行数'] > 1">
                    <b-tr :key="index2 + 'evaluationItem' + 1" v-if="index2 != 0">
                      <b-td rowspan="1" :class="!project['表示行1_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行1_評価項目名'][index2]}}</b-td>
                      <b-td rowspan="1" :class="!project['表示行1_総合評価対象'] ? 'align-middle no-pointer-events nonEvaluation' : ((project['評価商品テーブル']['value'].length <= 1 || !userEvaluationAuthority) ? 'align-middle no-pointer-events' : 'align-middle')">
                        <div class="stars" v-if="project['表示行1_評価項目名'][index2] != '総合評価'">
                          <span>
                            <input :id="'star1_' + index + '_1_' + index2" type="radio" :name="'star' + index + '_1_' + index2" v-model="project['表示行1_評価'][index2]" value="5" @change="viewComprehensiveEvaluationSub(index, 1)"><label :for="'star1_' + index + '_1_' + index2">★</label>
                            <input :id="'star2_' + index + '_1_' + index2" type="radio" :name="'star' + index + '_1_' + index2" v-model="project['表示行1_評価'][index2]" value="4" @change="viewComprehensiveEvaluationSub(index, 1)"><label :for="'star2_' + index + '_1_' + index2">★</label>
                            <input :id="'star3_' + index + '_1_' + index2" type="radio" :name="'star' + index + '_1_' + index2" v-model="project['表示行1_評価'][index2]" value="3" @change="viewComprehensiveEvaluationSub(index, 1)"><label :for="'star3_' + index + '_1_' + index2">★</label>
                            <input :id="'star4_' + index + '_1_' + index2" type="radio" :name="'star' + index + '_1_' + index2" v-model="project['表示行1_評価'][index2]" value="2" @change="viewComprehensiveEvaluationSub(index, 1)"><label :for="'star4_' + index + '_1_' + index2">★</label>
                            <input :id="'star5_' + index + '_1_' + index2" type="radio" :name="'star' + index + '_1_' + index2" v-model="project['表示行1_評価'][index2]" value="1" @click="viewEvaluationReset(index, 1, index2)" @change="viewComprehensiveEvaluationSub(index, 1)"><label :for="'star5_' + index + '_1_' + index2">★</label>
                          </span>
                        </div>
                        <div class="evaluationStars big-font" v-else>
                          {{project['表示行1_評価'][index2]}}
                          <!--
                          <span>
                            <label :class="project['表示行1_評価'][index2] > 4 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars1">★</label>
                            <label :class="project['表示行1_評価'][index2] > 3 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars2">★</label>
                            <label :class="project['表示行1_評価'][index2] > 2 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars3">★</label>
                            <label :class="project['表示行1_評価'][index2] > 1 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars4">★</label>
                            <label :class="project['表示行1_評価'][index2] > 0 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars5">★</label>
                          </span>
                          -->
                        </div>
                      </b-td>
                    </b-tr>
                  </template>
                  <b-tr :key="index + 'activeProject' + 2" v-if="project['表示行数'] > 2">
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行2_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行2_大区分']}}<br>
                      <input class="" type="checkbox" name="evaluationCheckBox" value="1" v-model="project['表示行2_総合評価対象']" @change="viewComprehensiveEvaluation(index)" :disabled="(project['評価商品テーブル']['value'].length <= 2 || !userEvaluationAuthority)">
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行2_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">
                      <b-button class="image-box" @click="handleOpenDialog(project['表示行2_画像'])">
                        <img :src="project['表示行2_画像']" class="mw-100 tile-image-height" v-if="project['表示行2_画像'] !== ''">
                      </b-button>
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行2_総合評価対象'] ? 'align-middle text-pre-wrap nonEvaluation' : 'align-middle text-pre-wrap'">{{project['表示行2_金額']}}</b-td>
                    <b-td rowspan="1" :class="!project['表示行2_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行2_評価項目名'][0]}}</b-td>
                    <b-td rowspan="1" :class="!project['表示行2_総合評価対象'] ? 'align-middle no-pointer-events nonEvaluation' : ((project['評価商品テーブル']['value'].length <= 2 || !userEvaluationAuthority) ? 'align-middle no-pointer-events' : 'align-middle')">
                      <div class="stars">
                        <span>
                          <input :id="'star1_' + index + '_2_0'" type="radio" :name="'star' + index + '_2_0'" v-model="project['表示行2_評価'][0]" value="5" @change="viewComprehensiveEvaluationSub(index, 2)"><label :for="'star1_' + index + '_2_0'">★</label>
                          <input :id="'star2_' + index + '_2_0'" type="radio" :name="'star' + index + '_2_0'" v-model="project['表示行2_評価'][0]" value="4" @change="viewComprehensiveEvaluationSub(index, 2)"><label :for="'star2_' + index + '_2_0'">★</label>
                          <input :id="'star3_' + index + '_2_0'" type="radio" :name="'star' + index + '_2_0'" v-model="project['表示行2_評価'][0]" value="3" @change="viewComprehensiveEvaluationSub(index, 2)"><label :for="'star3_' + index + '_2_0'">★</label>
                          <input :id="'star4_' + index + '_2_0'" type="radio" :name="'star' + index + '_2_0'" v-model="project['表示行2_評価'][0]" value="2" @change="viewComprehensiveEvaluationSub(index, 2)"><label :for="'star4_' + index + '_2_0'">★</label>
                          <input :id="'star5_' + index + '_2_0'" type="radio" :name="'star' + index + '_2_0'" v-model="project['表示行2_評価'][0]" value="1" @click="viewEvaluationReset(index, 2, 0)" @change="viewComprehensiveEvaluationSub(index, 2)"><label :for="'star5_' + index + '_2_0'">★</label>
                        </span>
                      </div>
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行2_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">
                      <b-form-textarea class="w-100 item-note" name="note" rows="8" max-rows="8" no-resize maxlength="300" :style="!project['表示行2_総合評価対象'] ? 'background-color: #e9ecef; padding:0.2rem;' : 'padding:0.2rem;'" v-model="project['表示行2_コメント']" @change="setRowEdit(index)" :disabled="(project['評価商品テーブル']['value'].length <= 2 || !userEvaluationAuthority || !project['表示行2_総合評価対象'])"></b-form-textarea>
                    </b-td>
                  </b-tr>
                  <template v-for="(evaluationItem, index2) in evaluationItems" v-if="project['表示行数'] > 2">
                    <b-tr :key="index2 + 'evaluationItem' + 2" v-if="index2 != 0">
                      <b-td rowspan="1" :class="!project['表示行2_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行2_評価項目名'][index2]}}</b-td>
                      <b-td rowspan="1" :class="!project['表示行2_総合評価対象'] ? 'align-middle no-pointer-events nonEvaluation' : ((project['評価商品テーブル']['value'].length <= 2 || !userEvaluationAuthority) ? 'align-middle no-pointer-events' : 'align-middle')">
                        <div class="stars" v-if="project['表示行2_評価項目名'][index2] != '総合評価'">
                          <span>
                            <input :id="'star1_' + index + '_2_' + index2" type="radio" :name="'star' + index + '_2_' + index2" v-model="project['表示行2_評価'][index2]" value="5" @change="viewComprehensiveEvaluationSub(index, 2)"><label :for="'star1_' + index + '_2_' + index2">★</label>
                            <input :id="'star2_' + index + '_2_' + index2" type="radio" :name="'star' + index + '_2_' + index2" v-model="project['表示行2_評価'][index2]" value="4" @change="viewComprehensiveEvaluationSub(index, 2)"><label :for="'star2_' + index + '_2_' + index2">★</label>
                            <input :id="'star3_' + index + '_2_' + index2" type="radio" :name="'star' + index + '_2_' + index2" v-model="project['表示行2_評価'][index2]" value="3" @change="viewComprehensiveEvaluationSub(index, 2)"><label :for="'star3_' + index + '_2_' + index2">★</label>
                            <input :id="'star4_' + index + '_2_' + index2" type="radio" :name="'star' + index + '_2_' + index2" v-model="project['表示行2_評価'][index2]" value="2" @change="viewComprehensiveEvaluationSub(index, 2)"><label :for="'star4_' + index + '_2_' + index2">★</label>
                            <input :id="'star5_' + index + '_2_' + index2" type="radio" :name="'star' + index + '_2_' + index2" v-model="project['表示行2_評価'][index2]" value="1" @click="viewEvaluationReset(index, 2, index2)" @change="viewComprehensiveEvaluationSub(index, 2)"><label :for="'star5_' + index + '_2_' + index2">★</label>
                          </span>
                        </div>
                        <div class="evaluationStars big-font" v-else>
                          {{project['表示行2_評価'][index2]}}
                          <!--
                          <span>
                            <label :class="project['表示行2_評価'][index2] > 4 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars1">★</label>
                            <label :class="project['表示行2_評価'][index2] > 3 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars2">★</label>
                            <label :class="project['表示行2_評価'][index2] > 2 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars3">★</label>
                            <label :class="project['表示行2_評価'][index2] > 1 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars4">★</label>
                            <label :class="project['表示行2_評価'][index2] > 0 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars5">★</label>
                          </span>
                          -->
                        </div>
                      </b-td>
                    </b-tr>
                  </template>
                  <b-tr :key="index + 'activeProject' + 3" v-if="project['表示行数'] > 3">
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行3_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行3_大区分']}}<br>
                      <input class="" type="checkbox" name="evaluationCheckBox" value="1" v-model="project['表示行3_総合評価対象']" @change="viewComprehensiveEvaluation(index)" :disabled="(project['評価商品テーブル']['value'].length <= 3 || !userEvaluationAuthority)">
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行3_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">
                      <b-button class="image-box" @click="handleOpenDialog(project['表示行3_画像'])">
                        <img :src="project['表示行3_画像']" class="mw-100 tile-image-height" v-if="project['表示行3_画像'] !== ''">
                      </b-button>
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行3_総合評価対象'] ? 'align-middle text-pre-wrap nonEvaluation' : 'align-middle text-pre-wrap'">{{project['表示行3_金額']}}</b-td>
                    <b-td rowspan="1" :class="!project['表示行3_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行3_評価項目名'][0]}}</b-td>
                    <b-td rowspan="1" :class="!project['表示行3_総合評価対象'] ? 'align-middle no-pointer-events nonEvaluation' : ((project['評価商品テーブル']['value'].length <= 3 || !userEvaluationAuthority) ? 'align-middle no-pointer-events' : 'align-middle')">
                      <div class="stars">
                        <span>
                          <input :id="'star1_' + index + '_3_0'" type="radio" :name="'star' + index + '_3_0'" v-model="project['表示行3_評価'][0]" value="5" @change="viewComprehensiveEvaluationSub(index, 3)"><label :for="'star1_' + index + '_3_0'">★</label>
                          <input :id="'star2_' + index + '_3_0'" type="radio" :name="'star' + index + '_3_0'" v-model="project['表示行3_評価'][0]" value="4" @change="viewComprehensiveEvaluationSub(index, 3)"><label :for="'star2_' + index + '_3_0'">★</label>
                          <input :id="'star3_' + index + '_3_0'" type="radio" :name="'star' + index + '_3_0'" v-model="project['表示行3_評価'][0]" value="3" @change="viewComprehensiveEvaluationSub(index, 3)"><label :for="'star3_' + index + '_3_0'">★</label>
                          <input :id="'star4_' + index + '_3_0'" type="radio" :name="'star' + index + '_3_0'" v-model="project['表示行3_評価'][0]" value="2" @change="viewComprehensiveEvaluationSub(index, 3)"><label :for="'star4_' + index + '_3_0'">★</label>
                          <input :id="'star5_' + index + '_3_0'" type="radio" :name="'star' + index + '_3_0'" v-model="project['表示行3_評価'][0]" value="1" @click="viewEvaluationReset(index, 3, 0)" @change="viewComprehensiveEvaluationSub(index, 3)"><label :for="'star5_' + index + '_3_0'">★</label>
                        </span>
                      </div>
                    </b-td>
                    <b-td :rowspan="evaluationItems.length" :class="!project['表示行3_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">
                      <b-form-textarea class="w-100 item-note" name="note" rows="8" max-rows="8" no-resize maxlength="300" :style="!project['表示行3_総合評価対象'] ? 'background-color: #e9ecef; padding:0.2rem;' : 'padding:0.2rem;'" v-model="project['表示行3_コメント']" @change="setRowEdit(index)" :disabled="(project['評価商品テーブル']['value'].length <= 3 || !userEvaluationAuthority || !project['表示行3_総合評価対象'])"></b-form-textarea>
                    </b-td>
                  </b-tr>
                  <template v-for="(evaluationItem, index2) in evaluationItems" v-if="project['表示行数'] > 3">
                    <b-tr :key="index2 + 'evaluationItem' + 3" v-if="index2 != 0">
                      <b-td rowspan="1" :class="!project['表示行3_総合評価対象'] ? 'align-middle nonEvaluation' : 'align-middle'">{{project['表示行3_評価項目名'][index2]}}</b-td>
                      <b-td rowspan="1" :class="!project['表示行3_総合評価対象'] ? 'align-middle no-pointer-events nonEvaluation' : ((project['評価商品テーブル']['value'].length <= 3 || !userEvaluationAuthority) ? 'align-middle no-pointer-events' : 'align-middle')">
                        <div class="stars" v-if="project['表示行3_評価項目名'][index2] != '総合評価'">
                          <span>
                            <input :id="'star1_' + index + '_3_' + index2" type="radio" :name="'star' + index + '_3_' + index2" v-model="project['表示行3_評価'][index2]" value="5" @change="viewComprehensiveEvaluationSub(index, 3)"><label :for="'star1_' + index + '_3_' + index2">★</label>
                            <input :id="'star2_' + index + '_3_' + index2" type="radio" :name="'star' + index + '_3_' + index2" v-model="project['表示行3_評価'][index2]" value="4" @change="viewComprehensiveEvaluationSub(index, 3)"><label :for="'star2_' + index + '_3_' + index2">★</label>
                            <input :id="'star3_' + index + '_3_' + index2" type="radio" :name="'star' + index + '_3_' + index2" v-model="project['表示行3_評価'][index2]" value="3" @change="viewComprehensiveEvaluationSub(index, 3)"><label :for="'star3_' + index + '_3_' + index2">★</label>
                            <input :id="'star4_' + index + '_3_' + index2" type="radio" :name="'star' + index + '_3_' + index2" v-model="project['表示行3_評価'][index2]" value="2" @change="viewComprehensiveEvaluationSub(index, 3)"><label :for="'star4_' + index + '_3_' + index2">★</label>
                            <input :id="'star5_' + index + '_3_' + index2" type="radio" :name="'star' + index + '_3_' + index2" v-model="project['表示行3_評価'][index2]" value="1" @click="viewEvaluationReset(index, 3, index2)" @change="viewComprehensiveEvaluationSub(index, 3)"><label :for="'star5_' + index + '_3_' + index2">★</label>
                          </span>
                        </div>
                        <div class="evaluationStars big-font" v-else>
                          {{project['表示行3_評価'][index2]}}
                          <!--
                          <span>
                            <label :class="project['表示行3_評価'][index2] > 4 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars1">★</label>
                            <label :class="project['表示行3_評価'][index2] > 3 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars2">★</label>
                            <label :class="project['表示行3_評価'][index2] > 2 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars3">★</label>
                            <label :class="project['表示行3_評価'][index2] > 1 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars4">★</label>
                            <label :class="project['表示行3_評価'][index2] > 0 ? 'evaluationStarsAc' : 'evaluationStarsNonAc'" key="evaluationStars5">★</label>
                          </span>
                          -->
                        </div>
                      </b-td>
                    </b-tr>
                  </template>
                </b-tbody>
              </template>
            </b-table-simple>
          </div>
        </div>
      </div>
    </b-overlay>
    <dialog ref="dialog" class="image-dialog" @click="handleCloseDialog">
      <div class="contents">
        <img :src="dialogImage" width="300" />
      </div>
    </dialog>
    <CommonModal title="" ref="commonModal"/>
  </CommonLayout>
</template>

<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import CookieDataModel from '@/models/CookieDataModel'
import AreaListModel from '@/models/AreaListModel'
import UnitListModel from '@/models/UnitListModel'
import ProductionBaseListModel from '@/models/ProductionBaseListModel'
import FacilityListModel from '@/models/FacilityListModel'
import EvaluationLoginModel from '@/models/EvaluationLoginModel'
import EvaluationSearchModel from '@/models/EvaluationSearchModel'
import EvaluationRegistModel from '@/models/EvaluationRegistModel'

export default {
  name: 'DeliveryEvaluation',
  components: {
    CommonLayout, CommonModal
  },
  data () {
    return {
      overlayShow: false,
      activeViewList: [],
      viewData: [],
      viewDataBk: [],
      viewLength: 0,
      page: 1,
      pageMaxNum: 5,
      pageStart: 0,
      pageEnd: 0,
      areaData: [],
      unitData: [],
      facilityData: [],
      productionBaseData: [],
      searchAreaName: [],
      searchUnitName: [],
      searchFacilityName: [],
      searchProductionBaseCode: [],
      searchDetailTypeName: [],
      searchDateFrom: '',
      searchDateTo: '',
      searchEvaluationSet: '',
      searchEvaluation: [],
      cookieIsAdmin: 0,
      cookieProdBaseCode: '',
      evaluationItems: ['花合わせ', '制作', '施工', '総合評価'],
      dialogImage: '',
      SortDirection: {},
      userId: '',
      userEvaluationAuthority: false,
      key: 0,
      fixedProductionBaseCode: ''
    }
  },
  methods: {
    setApiData: async function () {
      this.overlayShow = true
      console.log(this.$route.meta)
      console.log(this.$route.query)
      if ('prodBaseCode' in this.$route.query) {
        this.fixedProductionBaseCode = this.$route.query.prodBaseCode
      }
      if (this.$route.meta.userId) {
        this.userId = this.$route.meta.userId
        localStorage.setItem('evaluationUserId', this.userId)

        let res = await EvaluationLoginModel.getApi(this.$bvModal, {'userId': this.userId}, (result) => {}, () => {})
        console.log(res)
        if (res['tantosha'] === undefined) {
          console.log('tantosha:undefined')
        } else {
          if (res['tantosha'] && res['tantosha']['役割']) {
            console.log(res['tantosha']['役割']['value'])
            const userRole = res['tantosha']['役割']['value']
            const roleMode = {
              'システム管理者': 2,
              '運用管理者': 2,
              '本部マネージャー': 2,
              'エリアマネージャー': 1,
              'ユニットリーダー': 1,
              'チームリーダー': 1,
              'メンバー': 1,
              'プランナー': 0,
              'SDP': 0
            }
            this.userEvaluationAuthority = (((userRole in roleMode) ? roleMode[userRole] : 0) === 2)
            localStorage.setItem('evaluationAuthority', this.userEvaluationAuthority)
          }
          if (!this.userEvaluationAuthority && res['tantosha'] && res['tantosha']['評価権限']) {
            console.log(res['tantosha']['評価権限']['value'])
            this.userEvaluationAuthority = (res['tantosha']['評価権限']['value'].length > 0)
            localStorage.setItem('evaluationAuthority', this.userEvaluationAuthority)
          }
        }
      } else {
        if (this.fixedProductionBaseCode) {
          this.userEvaluationAuthority = false
        } else {
          this.userId = localStorage.getItem('evaluationUserId')
          this.userEvaluationAuthority = (localStorage.getItem('evaluationAuthority') === 'true')
        }
      }
      console.log(this.userId)
      console.log(this.userEvaluationAuthority)
      this.overlayShow = false
    },
    movePage (pageNum) {
      this.page = pageNum
      this.setActiveViewList()
    },
    onScroll: async function () {
      const bottomPosition = document.body.offsetHeight - (window.scrollY + window.innerHeight)
      if (bottomPosition < 56 && !this.overlayShow && this.viewLength > this.activeViewList.length) {
        this.overlayShow = true
        await this.movePage(this.page + 1)
        this.overlayShow = false
      }
    },
    setActiveViewList () {
      this.pageEnd = (this.page - 1) * this.pageMaxNum + this.pageMaxNum
      if (this.viewLength < this.pageEnd) {
        this.pageEnd = (this.page - 1) * this.pageMaxNum + (this.viewLength % this.pageMaxNum)
      }
      this.activeViewList = this.viewData.slice(this.pageStart, this.pageEnd)
    },
    setViewData: async function (data) {
      this.viewData = data['evaluations']['records']
      for (let i = 0; i < this.viewData.length; i++) {
        this.viewData[i]['No'] = {'value': i + 1}
        this.viewData[i]['edit'] = false
        // 表示行初期値
        const defSetRow = 1
        for (let j = 0; j < defSetRow; j++) {
          this.viewData[i]['表示行' + j + '_大区分'] = ''
          this.viewData[i]['表示行' + j + '_画像'] = ''
          this.viewData[i]['表示行' + j + '_金額'] = ''
          this.viewData[i]['表示行' + j + '_評価項目名'] = []
          this.viewData[i]['表示行' + j + '_評価'] = []
          for (let k = 0; k < this.evaluationItems.length; k++) {
            this.viewData[i]['表示行' + j + '_評価項目名'].push(this.evaluationItems[k])
            this.viewData[i]['表示行' + j + '_評価'].push('0')
          }
          this.viewData[i]['表示行' + j + '_コメント'] = ''
          this.viewData[i]['表示行' + j + '_総合評価対象'] = false
        }
        this.viewData[i]['表示行数'] = defSetRow

        let viewRow = this.viewData[i]['評価商品テーブル']['value']
        for (let j = 0; j < viewRow.length; j++) {
          this.viewData[i]['表示行' + j + '_大区分'] = viewRow[j]['value']['大区分']['value']
          this.viewData[i]['表示行' + j + '_画像'] = viewRow[j]['value']['画像']['value']
          this.viewData[i]['表示行' + j + '_金額'] = viewRow[j]['value']['金額']['value']
          this.viewData[i]['表示行' + j + '_評価項目名'] = []
          this.viewData[i]['表示行' + j + '_評価'] = []
          for (let k = 0; k < this.evaluationItems.length; k++) {
            this.viewData[i]['表示行' + j + '_評価項目名'].push(this.evaluationItems[k])
            let evaluationTable = this.viewData[i]['評価テーブル']['value']
            let evaluation = 0
            for (let l = 0; l < evaluationTable.length; l++) {
              if (evaluationTable[l]['value']['評価大区分']['value'] === viewRow[j]['value']['大区分']['value'] && evaluationTable[l]['value']['評価大区分連番']['value'] === viewRow[j]['value']['連番']['value'] && evaluationTable[l]['value']['評価項目']['value'] === this.evaluationItems[k]) {
                evaluation = evaluationTable[l]['value']['評価']['value']
                break
              }
            }
            this.viewData[i]['表示行' + j + '_評価'].push('' + evaluation)
          }
          let evaluationSubTable = this.viewData[i]['評価関係テーブル']['value']
          this.viewData[i]['表示行' + j + '_総合評価対象'] = true
          for (let l = 0; l < evaluationSubTable.length; l++) {
            if (evaluationSubTable[l]['value']['評価関係大区分']['value'] === viewRow[j]['value']['大区分']['value'] && evaluationSubTable[l]['value']['評価関係大区分連番']['value'] === viewRow[j]['value']['連番']['value']) {
              this.viewData[i]['表示行' + j + '_コメント'] = evaluationSubTable[l]['value']['コメント']['value']
              this.viewData[i]['表示行' + j + '_総合評価対象'] = (evaluationSubTable[l]['value']['総合評価対象外']['value'].length === 0)
              break
            }
          }
        }
        if (viewRow.length > this.viewData[i]['表示行数']) {
          this.viewData[i]['表示行数'] = viewRow.length
        }
      }

      this.viewLength = this.viewData.length
      // 総合評価を更新
      await this.viewComprehensiveEvaluationAll()
      // 1page目を表示
      await this.movePage(1)
      // 検索結果のバックアップ取得
      // バックアップはソートなしの状態として保存
      this.viewDataBk = []
      for (let i = 0; i < this.viewData.length; i++) {
        let defdata = Object.assign({}, this.viewData[i])
        for (let j = 0; j < this.viewData[i]['表示行数']; j++) {
          defdata['表示行' + j + '_評価'] = Object.assign([], this.viewData[i]['表示行' + j + '_評価'])
        }
        defdata['事例紹介'] = Object.assign({}, this.viewData[i]['事例紹介'])
        this.viewDataBk.push(defdata)
      }
      // 画面のソート状態でソート
      await this.sortKeep()
    },
    evaluationSearch () {
      this.page = 1
      this.overlayShow = true
      const getData = {
        'searchAreaName': this.searchAreaName,
        'areaName': this.getSelectListDict(this.getSearchSelect(this.searchAreaName, this.areaData)),
        'searchUnitName': this.searchUnitName,
        'unitName': this.getSelectListDict(this.getSearchSelect(this.searchUnitName, this.unitData)),
        'searchFacilityName': this.searchFacilityName,
        'facilityName': this.getSelectListDict(this.getSearchSelect(this.searchFacilityName, this.facilityData)),
        'searchProductionBaseCode': this.searchProductionBaseCode,
        'productionBaseCode': this.getSelectListDict(this.getSearchSelect(this.searchProductionBaseCode, this.productionBaseData)),
        'detailTypeName': this.getSelectListDict(this.searchDetailTypeName),
        'evaluationSet': this.searchEvaluationSet,
        'evaluation': this.getSelectListDict(this.searchEvaluation),
        'weddingDateFrom': this.searchDateFrom,
        'weddingDateTo': this.searchDateTo,
        'fixedProductionBaseCode': this.fixedProductionBaseCode
      }
      EvaluationSearchModel.getApi(this.$bvModal, getData, (data) => {
        // データ加工
        this.setViewData(data)
      }, () => {
        this.overlayShow = false
      })

      // 検索条件を保存
      localStorage.setItem('searchEvaluation', JSON.stringify(getData))
    },
    clearConditions: async function () {
      this.overlayShow = true
      // $('.datepicker').datepicker({
      //  format: 'mm/dd/yyyy',
      //  startDate: '-3d'
      // })

      let deliverabldeate = await this.getDeliverableDate()
      // 当月の1日
      this.searchDateFrom = deliverabldeate[0]
      // 当月の月末
      this.searchDateTo = deliverabldeate[1]

      this.searchAreaName = []
      this.searchUnitName = []
      this.searchFacilityName = []
      this.searchProductionBaseCode = []
      this.searchDetailTypeName = []

      this.searchEvaluationSet = '0'
      let idObj = document.getElementById('inlineRadio2')
      if (idObj !== null) {
        idObj.click()
        idObj.checked = true
      }

      this.searchEvaluation = []

      this.overlayShow = false

      // 強制再描画
      this.$forceUpdate()

      this.key++
    },
    formatDate (date) {
      // 日付のフォーマット
      const newDate = new Date(date)
      const weekday = ['日', '月', '火', '水', '木', '金', '土']
      let format = 'YYYY/MM/DD(WW)'
      format = format.replace(/YYYY/g, newDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (newDate.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + newDate.getDate()).slice(-2))
      format = format.replace(/WW/g, weekday[newDate.getDay()])
      format = format.replace(/hh/g, ('0' + newDate.getHours()).slice(-2))
      format = format.replace(/mm/g, ('0' + newDate.getMinutes()).slice(-2))
      return format
    },
    getDeliverableDate () {
      // 施工日の初期値配列を取得
      const newDate = new Date()
      const fromday = new Date(newDate.getFullYear(), newDate.getMonth(), 1)
      let fromdate = 'YYYY-MM-DD'
      fromdate = fromdate.replace(/YYYY/, fromday.getFullYear())
      fromdate = fromdate.replace(/MM/, fromday.getMonth() + 1 >= 10 ? fromday.getMonth() + 1 : '0' + (fromday.getMonth() + 1))
      fromdate = fromdate.replace(/DD/, fromday.getDate() >= 10 ? fromday.getDate() : '0' + fromday.getDate())

      const today = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0)
      let todate = 'YYYY-MM-DD'
      todate = todate.replace(/YYYY/, today.getFullYear())
      todate = todate.replace(/MM/, today.getMonth() + 1 >= 10 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1))
      todate = todate.replace(/DD/, today.getDate() >= 10 ? today.getDate() : '0' + today.getDate())

      const deliverableDate = [ fromdate, todate ]
      return deliverableDate
    },
    changeListType (target) {
      if (target === 'dataList') {
        this.$router.push('/project_list?list_type=dataList')
      } else {
        this.$router.push('/project_list?list_type=projectList')
      }
    },
    changeIcon () {
      document.getElementById('icon-up').classList.toggle('hide')
      document.getElementById('icon-down').classList.toggle('hide')
    },
    pageBackSetUp () {
      // 現在の仕様では動かないので、念のため
      const searchEvaluations = JSON.parse(localStorage.getItem('searchEvaluation'))
      for (const [key, value] of Object.entries(searchEvaluations)) {
        if (key === 'searchAreaName') {
          this.searchAreaName = value
        } else if (key === 'searchUnitName') {
          this.searchUnitName = value
        } else if (key === 'searchFacilityName') {
          this.searchFacilityName = value
        } else if (key === 'searchProductionBaseCode') {
          this.searchProductionBaseCode = value
        } else if (key === 'detailTypeName') {
          this.searchDetailTypeName = value
        } else if (key === 'evaluationSet') {
          this.searchEvaluationSet = value
        } else if (key === 'evaluation') {
          this.searchEvaluation = value
        } else if (key === 'weddingDateFrom') {
          this.searchDateFrom = value
        } else if (key === 'weddingDateTo') {
          this.searchDateTo = value
        }
      }
      this.evaluationSearch()
      localStorage.removeItem('isOrderPageBack')
    },
    setCookieData: async function () {
      this.CookieData = await CookieDataModel.getApi(this.$bvModal, () => {})
      if (this.CookieData) {
        if (this.CookieData['cookieData']['custom:IsAdmin']) {
          this.cookieIsAdmin = this.CookieData['cookieData']['custom:IsAdmin']
        }
        if (this.CookieData['cookieData']['custom:ProdBaseCode']) {
          this.cookieProdBaseCode = this.CookieData['cookieData']['custom:ProdBaseCode']
        }
        /*
        if (!this.searchProductionBaseCode) {
          this.searchProductionBaseCode = this.cookieProdBaseCode
        }
        */
      }
    },

    setSelectItems: async function () {
      let areas = (await AreaListModel.getApi(this.$bvModal))['areas']
      this.areaData = []
      if (!areas) {
        this.areaData.push({ 'label': '', 'value': '' })
        return
      }
      for (let i = 0; i < areas['records'].length; i++) {
        this.areaData.push({ 'label': areas['records'][i]['エリア名'].value, 'value': this.areaData.length, 'searchValue': areas['records'][i]['エリア名'].value })
      }

      let units = (await UnitListModel.getApi(this.$bvModal))['units']
      this.unitData = []
      if (!units) {
        this.unitData.push({ 'label': '', 'value': '' })
        return
      }
      for (let i = 0; i < units['records'].length; i++) {
        this.unitData.push({ 'label': units['records'][i]['ユニット名'].value, 'value': this.unitData.length, 'searchValue': units['records'][i]['ユニット名'].value })
      }
      let facilities = ''
      if (this.fixedProductionBaseCode) {
        facilities = (await FacilityListModel.getApi(this.$bvModal, {'productionBaseCode': this.fixedProductionBaseCode}))['facilities']
      } else {
        facilities = (await FacilityListModel.getApi(this.$bvModal, {'allData': true}))['facilities']
      }
      this.facilityData = []
      if (!facilities) {
        this.facilityData.push({ 'label': '', 'value': '' })
        return
      }
      for (let i = 0; i < facilities['records'].length; i++) {
        this.facilityData.push({ 'label': facilities['records'][i]['施設名'].value, 'value': this.facilityData.length, 'searchValue': facilities['records'][i]['施設名'].value })
      }

      let productionBases = (await ProductionBaseListModel.getApi(this.$bvModal))['productionBases']
      this.productionBaseData = []
      if (!productionBases) {
        this.productionBaseData.push({ 'label': '', 'value': '' })
        return
      }
      for (let i = 0; i < productionBases['records'].length; i++) {
        if (!this.fixedProductionBaseCode) {
          this.productionBaseData.push({ 'label': productionBases['records'][i]['制作拠点名'].value, 'value': this.productionBaseData.length, 'searchValue': productionBases['records'][i]['制作拠点コード'].value })
        } else {
          if (this.fixedProductionBaseCode === productionBases['records'][i]['制作拠点コード'].value) {
            this.productionBaseData.push({ 'label': productionBases['records'][i]['制作拠点名'].value, 'value': this.productionBaseData.length, 'searchValue': productionBases['records'][i]['制作拠点コード'].value })
            this.searchProductionBaseCode.push(0)
            break
          }
        }
      }
    },
    getSearchSelect (numList, dataList) {
      let res = []
      for (let i = 0; i < numList.length; i++) {
        res.push(dataList[numList[i]].searchValue)
      }
      return res
    },
    getSelectListDict (dataList) {
      let res = {}
      for (let i = 0; i < dataList.length; i++) {
        res[dataList[i]] = dataList[i]
      }
      return res
    },
    setUnits: async function () {
      // 検索値初期化
      this.searchUnitName = []

      // 選択肢絞込み
      let units = UnitListModel.getStore('units')
      this.unitData = []
      if (!units) {
        this.unitData.push({ 'label': '', 'value': '' })
        return
      }
      for (let i = 0; i < units['records'].length; i++) {
        let addflg = (this.searchAreaName.length === 0)
        for (let j = 0; j < this.searchAreaName.length; j++) {
          if (this.areaData[this.searchAreaName[j]]['label'] === units['records'][i]['所属エリア'].value) {
            addflg = true
            break
          }
        }
        if (addflg) {
          this.unitData.push({ 'label': units['records'][i]['ユニット名'].value, 'value': this.unitData.length, 'searchValue': units['records'][i]['ユニット名'].value })
        }
      }
      // 空ならダミーデータを入れる
      if (this.unitData.length === 0) {
        this.unitData.push({ 'label': '', 'value': '', 'searchValue': '' })
      }
    },
    setFacilities: async function () {
      // 検索値初期化
      this.searchFacilityName = []

      // 選択肢絞込み
      let facilities = FacilityListModel.getStore('facilities')
      this.facilityData = []
      if (!facilities) {
        this.facilityData.push({ 'label': '', 'value': '' })
        return
      }
      for (let i = 0; i < facilities['records'].length; i++) {
        let areaflg = (this.searchAreaName.length === 0)
        for (let j = 0; j < this.searchAreaName.length; j++) {
          if (this.areaData[this.searchAreaName[j]]['label'] === facilities['records'][i]['担当エリア'].value) {
            areaflg = true
            break
          }
        }
        let unitflg = (this.searchUnitName.length === 0)
        for (let j = 0; j < this.searchUnitName.length; j++) {
          if (this.unitData[this.searchUnitName[j]]['label'] === facilities['records'][i]['担当ユニット'].value) {
            unitflg = true
            break
          }
        }
        if (areaflg && unitflg) {
          this.facilityData.push({ 'label': facilities['records'][i]['施設名'].value, 'value': this.facilityData.length, 'searchValue': facilities['records'][i]['施設名'].value, 'hideValue': facilities['records'][i]['制作拠点コード'].value })
        }
      }
      // 空ならダミーデータを入れる
      if (this.facilityData.length === 0) {
        this.facilityData.push({ 'label': '', 'value': '', 'searchValue': '', 'hideValue': '' })
      }
    },
    setProductionBases: async function () {
      // 検索値初期化
      this.searchProductionBaseCode = []

      // 選択肢絞込み
      let productionBases = ProductionBaseListModel.getStore('productionBases')
      this.productionBaseData = []
      if (!productionBases) {
        this.productionBaseData.push({ 'label': '', 'value': '' })
        return
      }
      for (let i = 0; i < productionBases['records'].length; i++) {
        let addflg = false
        if (this.searchFacilityName.length === 0) {
          for (let j = 0; j < this.facilityData.length; j++) {
            if (this.facilityData[j]['hideValue'] === productionBases['records'][i]['制作拠点コード'].value) {
              addflg = true
              break
            }
          }
        } else {
          for (let j = 0; j < this.searchFacilityName.length; j++) {
            if (this.facilityData[this.searchFacilityName[j]]['hideValue'] === productionBases['records'][i]['制作拠点コード'].value) {
              addflg = true
              break
            }
          }
        }
        if (addflg) {
          this.productionBaseData.push({ 'label': productionBases['records'][i]['制作拠点名'].value, 'value': this.productionBaseData.length, 'searchValue': productionBases['records'][i]['制作拠点コード'].value })
        }
      }
      // 空ならダミーデータを入れる
      if (this.productionBaseData.length === 0) {
        this.productionBaseData.push({ 'label': '', 'value': '', 'searchValue': '' })
      }
    },
    getDetailType () {
      let detailTypes = ['本番', '前撮り', 'サンプル', 'アフター', 'キャンセル・延期', 'その他(売上計上あり)1', 'その他(売上計上あり)2', 'その他(売上計上なし)']
      let detailTypesValue = ['本番', '前撮り', 'サンプル', 'アフター', 'キャンセル・延期', 'その他(売上計上あり)1', 'その他(売上計上あり)2', 'その他(売上計上なし)']
      let res = []
      for (let i = 0; i < detailTypes.length; i++) {
        res.push({ 'label': detailTypes[i], 'value': detailTypesValue[i] })
      }
      return res
    },
    getEvaluation () {
      let EvaluationTypes = ['★☆☆☆☆', '★★☆☆☆', '★★★☆☆', '★★★★☆', '★★★★★']
      let res = []
      for (let i = 0; i < EvaluationTypes.length; i++) {
        res.push({ 'label': EvaluationTypes[i], 'value': (i + 1) })
      }
      return res
    },

    viewEvaluationReset (index, rowNo, index2) {
      if (this.activeViewList[index]['表示行' + rowNo + '_評価'][index2] === '1') {
        // 変更前に戻す
        this.activeViewList[index]['表示行' + rowNo + '_評価'][index2] = this.viewDataBk[this.viewData[index]['No'].value - 1]['表示行' + rowNo + '_評価'][index2]
        // 総合評価最新化
        this.viewComprehensiveEvaluationSub(index, rowNo)
      }
    },
    viewComprehensiveEvaluationSub (index, rowNo) {
      let comEvaSum = 0
      let comEvaNum = -1
      for (let k = 0; k < this.evaluationItems.length; k++) {
        if (this.evaluationItems[k] === '総合評価') {
          comEvaNum = k
        } else {
          comEvaSum += parseInt(this.activeViewList[index]['表示行' + rowNo + '_評価'][k])
        }
      }
      if (comEvaNum !== -1) {
        this.activeViewList[index]['表示行' + rowNo + '_評価'][comEvaNum] = '' + (comEvaSum / (this.evaluationItems.length - 1)).toFixed(1)
        let dummy = this.activeViewList[index]
        this.activeViewList.splice(index, 1, dummy)
      }
      this.viewComprehensiveEvaluation(index)
    },
    viewComprehensiveEvaluation (index) {
      let sumCount = 0
      let comEvaSum = 0
      for (let j = 0; j < this.activeViewList[index]['表示行数']; j++) {
        if (this.activeViewList[index]['表示行' + j + '_総合評価対象']) {
          for (let k = 0; k < this.evaluationItems.length; k++) {
            if (this.evaluationItems[k] !== '総合評価') {
              comEvaSum += parseInt(this.activeViewList[index]['表示行' + j + '_評価'][k])
              sumCount++
            }
          }
        }
      }
      if (sumCount !== 0) {
        this.activeViewList[index]['総合評価']['value'] = '' + (comEvaSum / sumCount).toFixed(1)
      } else {
        this.activeViewList[index]['総合評価']['value'] = '0.0'
      }
      let dummy = this.activeViewList[index]
      this.activeViewList.splice(index, 1, dummy)

      // 編集フラグを立てる
      this.setRowEdit(index)
    },
    viewComprehensiveEvaluationAll () {
      for (let i = 0; i < this.viewData.length; i++) {
        let bigComEvaSum = 0
        let sumCount = 0
        for (let j = 0; j < this.viewData[i]['表示行数']; j++) {
          // 大区分ごとの総合評価の更新
          let comEvaSum = 0
          let comEvaNum = -1
          for (let k = 0; k < this.evaluationItems.length; k++) {
            if (this.evaluationItems[k] === '総合評価') {
              comEvaNum = k
            } else {
              comEvaSum += parseInt(this.viewData[i]['表示行' + j + '_評価'][k])

              // 行の総合評価の評価合計値と加算回数
              if (this.viewData[i]['表示行' + j + '_総合評価対象']) {
                bigComEvaSum += parseInt(this.viewData[i]['表示行' + j + '_評価'][k])
                sumCount++
              }
            }
          }
          if (comEvaNum !== -1) {
            this.viewData[i]['表示行' + j + '_評価'][comEvaNum] = '' + (comEvaSum / (this.evaluationItems.length - 1)).toFixed(1)
          }
        }
        // 行の総合評価の更新
        if (sumCount !== 0) {
          this.viewData[i]['総合評価']['value'] = '' + (bigComEvaSum / sumCount).toFixed(1)
        } else {
          this.viewData[i]['総合評価']['value'] = '0.0'
        }
      }
    },
    changeToggle (index) {
      if (this.activeViewList[index]['事例紹介']['value'].length !== 0) {
        this.activeViewList[index]['事例紹介']['value'] = []
        document.getElementById('toggle-display' + index).checked = false
      } else {
        this.activeViewList[index]['事例紹介']['value'] = ['事例紹介ON']
        document.getElementById('toggle-display' + index).checked = true
      }
      // 編集フラグを立てる
      this.setRowEdit(index)
    },

    evaluationRegist: async function () {
      this.overlayShow = true

      let updateDate = []
      let errerList = []

      for (let i = 0; i < this.viewData.length; i++) {
        console.log(i)
        console.log(this.viewData[i]['edit'])
        if (!this.viewData[i]['edit']) {
          // 編集行でなければ飛ばす
          continue
        }
        let addErrFlg = false

        this.viewData[i]['評価テーブル'] = {'value': []}
        this.viewData[i]['評価関係テーブル'] = {'value': []}

        for (let j = 0; j < this.viewData[i]['評価商品テーブル']['value'].length; j++) {
          for (let k = 0; k < this.viewData[i]['表示行' + j + '_評価項目名'].length; k++) {
            let addData = {
              'value': {
                '評価大区分': {'value': this.viewData[i]['評価商品テーブル']['value'][j]['value']['大区分']['value']},
                '評価大区分連番': {'value': this.viewData[i]['評価商品テーブル']['value'][j]['value']['連番']['value']},
                '評価項目': {'value': this.viewData[i]['表示行' + j + '_評価項目名'][k]},
                '評価': {'value': (this.viewData[i]['表示行' + j + '_総合評価対象'] ? parseFloat(this.viewData[i]['表示行' + j + '_評価'][k]) : 0)}
              }
            }
            this.viewData[i]['評価テーブル']['value'].push(addData)

            // エラーチェック。総合評価対象でかつ、評価画像があるのに評価が設定されていないデータはエラー
            if (this.viewData[i]['表示行' + j + '_総合評価対象'] && parseInt(this.viewData[i]['表示行' + j + '_評価'][k]) === 0) {
              addErrFlg = true
            }
          }

          let addData = {
            'value': {
              '評価関係大区分': {'value': this.viewData[i]['評価商品テーブル']['value'][j]['value']['大区分']['value']},
              '評価関係大区分連番': {'value': this.viewData[i]['評価商品テーブル']['value'][j]['value']['連番']['value']},
              'コメント': {'value': this.viewData[i]['表示行' + j + '_コメント']},
              '総合評価対象外': {'value': (this.viewData[i]['表示行' + j + '_総合評価対象'] ? [] : ['対象外'])}
            }
          }
          this.viewData[i]['評価関係テーブル']['value'].push(addData)
        }

        if (addErrFlg) {
          let addErrData = {
            '行番号': this.viewData[i]['No']['value'],
            '案件No': this.viewData[i]['案件番号']['value'],
            'ご両家名': this.viewData[i]['ご両家名']['value']
          }
          errerList.push(addErrData)
        } else {
          updateDate.push(this.viewData[i])
        }
      }

      // 評価未完了エラーメッセージ表示
      if (errerList.length > 0) {
        const errListMax = 5
        let str = '評価の完了していない案件があります。(' + errerList.length + ' 件)\n'
        for (let i = 0; i < errListMax && i < errerList.length; i++) {
          str += '行番号：' + errerList[i]['行番号'] + '　案件No：' + errerList[i]['案件No'] + '　ご両家名：' + errerList[i]['ご両家名'] + '\n'
        }
        if (errerList.length > errListMax) {
          str += '……'
        }
        // 改行用のクラスを追加
        this.$refs.commonModal.confirmBox(str, null, '確認', 'text-pre-wrap', 'md')
        this.overlayShow = false
        return false
      }
      // 画面未入力エラーメッセージ表示
      if (updateDate.length === 0) {
        this.$refs.commonModal.confirmBox('画面入力が行われておりません。')
        this.overlayShow = false
        return false
      }

      // 更新処理
      const updateRecodeMax = 50
      console.log(updateDate)
      for (let i = 0; i < updateDate.length; i += updateRecodeMax) {
        let updateEnd = i + updateRecodeMax
        if (updateEnd > updateDate.length) {
          updateEnd = updateDate.length
        }
        let updateDateSub = updateDate.slice(i, updateEnd)
        console.log(updateDateSub)
        EvaluationRegistModel.postApi(this.$bvModal, updateDateSub, (result) => {
        },
        () => {
        })
      }

      // 現在のデータをBkに置き換える
      for (let i = 0; i < this.viewData.length; i++) {
        if (!this.viewData[i]['edit']) {
          // 編集行でなければ飛ばす
          continue
        }
        this.viewDataBk[this.viewData[i]['No'].value - 1] = Object.assign({}, this.viewData[i])
        this.viewData[i]['edit'] = false
      }

      this.$refs.commonModal.confirmBox('評価情報を更新いたしました。')
      this.overlayShow = false
      return true
    },
    caseIntroductionJudge () {
    },

    handleOpenDialog (imgAddress) {
      if (this.$refs.dialog) {
        this.dialogImage = imgAddress
        this.$refs.dialog.showModal()
      }
    },
    handleCloseDialog () {
      if (this.$refs.dialog) {
        this.$refs.dialog.close()
      }
    },

    moveDeliveredImage (recordId) {
      let resolvedRoute = this.$router.resolve({
        name: 'DeliveredImageSp',
        params: {projectNumber: recordId}
      })
      window.open(resolvedRoute.href, '_blank')
    },

    sortBy (key) {
      this.iniSortDirection(key)
      this.sortSet(key, this.getSortDirection(key), (key === 'No' ? 'num' : 'str'))
    },
    sortSet (key, sortType = 'asc', type = 'str') {
      this.overlayShow = true

      if (sortType !== '') {
        let ProjectList = this.viewData
        this.viewData = []
        setTimeout(() => {
          let trueSort = 1 // 降順ソート
          let folseSort = -1 // 降順ソート
          if (sortType !== 'desc') {
            trueSort = -1 // 昇順ソート
            folseSort = 1 // 昇順ソート
          }
          if (type === 'num') {
            ProjectList = ProjectList.sort(function (a, b) {
              return (Number(a[key]['value']) < Number(b[key]['value'])) ? trueSort : folseSort
            })
          } else {
            ProjectList = ProjectList.sort(function (a, b) {
              return (a[key]['value'] < b[key]['value']) ? trueSort : folseSort
            })
          }
          this.viewData = ProjectList
          this.setActiveViewList()
        }, 100)
      }

      this.overlayShow = false
    },
    getSortDirection (key) {
      if (this.SortDirection[key] === 'asc') {
        this.SortDirection[key] = 'desc'
        return 'desc'
      } else {
        this.SortDirection[key] = 'asc'
        return 'asc'
      }
    },
    iniSortDirection (key = '') {
      for (const [setKey] of Object.entries(this.SortDirection)) {
        if (key !== setKey) {
          this.SortDirection[setKey] = ''
        }
      }
    },
    strSortDirection (key) {
      let keysort = this.SortDirection[key]
      if (keysort === 'asc') {
        return ' ▲'
      }
      if (keysort === 'desc') {
        return ' ▼'
      }
      return ''
    },
    sortKeep (key) {
      for (const [setKey] of Object.entries(this.SortDirection)) {
        if (this.SortDirection[setKey] !== '') {
          this.sortSet(setKey, this.SortDirection[setKey], (key === 'No' ? 'num' : 'str'))
        }
      }
    },

    setRowEdit (index) {
      // 検索・保存時のデータと入力後のデータを比較する。
      // 一致していなければ編集あり。
      this.activeViewList[index]['edit'] = false
      let newdata = Object.assign({}, this.viewData[index])
      let olddata = Object.assign({}, this.viewDataBk[this.viewData[index]['No'].value - 1])
      // 更新時に書き換わる項目を同値にする。
      newdata['評価テーブル'] = {'value': []}
      newdata['評価関係テーブル'] = {'value': []}
      olddata['評価テーブル'] = {'value': []}
      olddata['評価関係テーブル'] = {'value': []}
      let newstr = JSON.stringify(newdata)
      let oldstr = JSON.stringify(olddata)
      this.activeViewList[index]['edit'] = (newstr !== oldstr)
      console.log(this.activeViewList[index]['edit'])
    }
  },
  computed: {
    getSearchAreaName () {
      return this.searchAreaName
    },
    getSearchUnitName () {
      return this.searchUnitName
    },
    getSearchFacilityName () {
      return this.searchFacilityName
    }
  },
  watch: {
    getSearchAreaName: function (newData, oldData) {
      this.setUnits()
      this.setFacilities()
      if (!this.fixedProductionBaseCode) {
        this.setProductionBases()
      }
    },
    getSearchUnitName: function (newData, oldData) {
      this.setFacilities()
      if (!this.fixedProductionBaseCode) {
        this.setProductionBases()
      }
    },
    getSearchFacilityName: function (newData, oldData) {
      if (!this.fixedProductionBaseCode) {
        this.setProductionBases()
      }
    }
  },
  mounted: async function () {
    await this.setApiData()
    if (this.userId || this.fixedProductionBaseCode) {
      // ソートを初期化
      await this.iniSortDirection()

      // 現在の仕様ではクッキーデータを使用しない
      // await this.setCookieData()
      if (JSON.parse(localStorage.getItem('isOrderPageBack'))) {
        this.pageBackSetUp()
      } else {
        this.clearConditions()
      }

      // 選択肢の情報を取得
      await this.setSelectItems()
    }
  },
  created () {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style scoped>
table > thead > tr > th {
  background-color: #004d00 !important;
  border: 1px solid #dee2e6 !important;
  color: #fefefe;
  font-weight: normal;
}
.form-group-date {
  padding-left: 15px;
}
.active-list {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
}
.list-type {
  padding: 0.5rem;
  color: #fefefe;
}
.list-type:hover {
  color: #fefefe;
  cursor: pointer;
}
.active-list {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
}
.active-list:hover {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
  cursor: default;
  text-decoration: none;
}
table {
  border-collapse: separate;
  border-spacing: 0px;
}
thead {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1;
}
th, td {
  padding: 0px 10px !important;
}
.white-line {
background-color: #fff;
}
.white-line:hover {
background-color: #9cd196 !important;
}
.gray-line {
background-color: #eefdff;
}
.gray-line:hover {
background-color: #9cd196 !important;
}

.stars span{
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
}
.stars input[type='radio']{
  display: none;
}
.stars label{
  color: #D2D2D2;
  font-size: 20px;
  cursor: pointer;
}
.stars label:hover,
.stars label:hover ~ label,
.stars input[type='radio']:checked ~ label{
  color: #F8C601;
}

.evaluationStars span{
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
}
.evaluationStarsNonAc{
  color: #D2D2D2;
  font-size: 20px;
}
.evaluationStarsAc{
  color: #F8C601;
  font-size: 20px;
}

.nonEvaluation{
  background: #f3f3f3;
}

.big-font {
  font-size: 20px;
  margin-bottom: .5rem;
}
.so-big-font {
  font-size: 300%;
}
.item-note {
  font-size: 0.7rem!important;
  padding: 0px;
}
.item-note:disabled {
  font-size: 0.7rem!important;
  padding: 0px;
  background-color: #f6f9fb;
  opacity: 1;
}

.image-box {
  cursor: zoom-in;
  display: inline-block;
  padding: 0px;
  background-color: #FFF;
  border-color: #FFF;
}
.image-dialog {
  padding: 0;
  &::backdrop {
    cursor: zoom-out;
  }
  .contents img {
    vertical-align: top;
    height: 90vh;
    width: 70vw;
    object-fit: contain;
  }
}

.move_link {
  color: #007bFF;
  cursor: pointer;
}

.no-pointer-events {
  Pointer-events: none;
}

.disp-none {
  display: none;
}

.light-green {
  background-color: #DAF2DA !important;
  color: #212529 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/DeliveryEvaluation.vue